import axios from '../../axios'

/**
 * 查询教练车轨迹列表
 * @param {*} data 
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=19170734 20230302 
 */
export const listTrajectory = data => {
  return axios({
    url: '/hourRecord/superposition',
    method: 'post', data
  })
}

/*
 * 教学区域模块
 */

/**
 * 导出Excel
 * @param inscode 驾校编号
 * @param  type 教学区域类型 1:第二部分； 2:第三部分；3:课堂教学；4:模拟器教学
 * @wiki http://wiki.sdjpw.com.cn/pages/viewpage.action?pageId=702566
 */
export const exportExcel = data => {
  return axios({
    url: '/region/exportExcel',
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 保存
export const save = (data) => {
    return axios({
        url: '/region/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/region/delete',
        method: 'post',
        data
    })
}
// 分页查询
export const findPage = (data) => {
    return axios({
        url: '/region/list',
        method: 'post',
        data
    })
}
// 分页查询
export const detailView = (data) => {
    return axios({
        url: '/region/detail',
        method: 'post',
        data
    })
}
// 删除
export const auditRegion = (data) => {
  return axios({
    url: '/region/report/'+data,
    method: 'post'
  })
}
// 获取教学区域
export const getRegion = (data) => {
  return axios({
    url: '/region/getRegion',
    method: 'post',
    data
  })
}
// 获取教学区域列表
export const getRegionList = (data) => {
  return axios({
    url: '/region/getRegionList',
    method: 'post',
    data
  })
}

// 查询教学区域审核结果
export const review = (data) => {
  return axios({
    url: '/region/review',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/modules/region/region.js